module.exports = __webpack_public_path__ + "img/erik.dea451e9.jpg";